import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CustomerRelatedListsService {
  constructor(private httpClient: HttpClient) {}

  listAccesses(customerId: string): Observable<unknown> {
    return this.httpClient.post(`${API_PATH}customer-acess/filter`, {
      customerId,
      getRelation: 1,
      limit: 100,
      page: 0,
      filter: '',
    });
  }

  listCharges(customerId: string): Observable<unknown> {
    return this.httpClient.post(`${API_PATH}charges/filter`, {
      getRelation: 1,
      limit: 100,
      page: 0,
      filter: { customerId, startDate: '2000-01-01' },
    });
  }
}
